// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__26xic","productName":"Table_productName__1eP2m"};